import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";
import React, {ReactElement, useEffect, useState} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "./StyledComponents";
import {Button, IconButton, TextField, Tooltip, Typography, useTheme} from "@mui/material";
import {PD_LG, PD_MD} from "./dimens";
import {CheckOutlined, CloseOutlined} from "@mui/icons-material";

export function FormGenArrayString(props: {
  contentItem: FormGenContentItem,
  index: number,
  source: FormGenLayoutSource,
}): ReactElement {
  const contentItem = props.contentItem;
  const [array, setArray] = useState<string[]>((props.source.getValue(contentItem) as Array<string>) || []);
  const [add, setAdd] = useState<string>("");
  useEffect(() => {
    props.source.setValue(props.contentItem, array);
  }, [array]);
  const theme = useTheme();
  return <StyledBoxColumn>
    {array?.length > 0
      ? array.map((value, index) =>
        <StyledBoxRow style={{width: "100%"}}>
          <TextField
            style={{flexGrow: 1}}
            size={"small"}
            disabled
            value={value}
            onChange={(event) => {
              array[index] = event.target.value;
            }}
            id={contentItem.id} variant="outlined"
            required/>
          <Tooltip title="Remove">
            <IconButton
              onClick={() => setArray([...array.slice(0, index), ...array.slice(index + 1)])}>
              <CloseOutlined/>
            </IconButton>
          </Tooltip>
        </StyledBoxRow>
      )
      : <Typography variant={"body2"} style={{textAlign: "center", padding: PD_MD}}><i>List is empty</i></Typography>
    }
    <StyledBoxColumn style={{marginTop: PD_MD, marginBottom: PD_MD, padding: PD_LG, background: theme.palette.background.paper}}>
      <StyledBoxRow style={{alignItems: "center", padding: PD_MD}}>
        <Typography variant={"body2"}>Click the "Add" button to add this item to the list.</Typography>
        <StyledSpan/>
        <Button
          variant={"contained"}
          startIcon={<CheckOutlined/>}
          onClick={() => {
            setArray([...array, add.trim()]);
            setAdd("");
          }}
          disabled={!Boolean(add?.trim().length > 0)}>
          Add
        </Button>
      </StyledBoxRow>
      <TextField
        size={"small"}
        autoFocus
        onChange={(event) => {
          setAdd(event.target.value);
        }}
        value={add}
        id={contentItem.id}
        variant="outlined"
        required/>
    </StyledBoxColumn>
  </StyledBoxColumn>;
}